const DetailBox = {

    init() {

        this.el = $('[component="DetailBox"]');

        if (!this.el.length) {
            return;
        }

        this.content = this.el.find("section.content");
        this.loading = this.el.find(".loading");
        this.buttonHide = this.el.find("button.hide");
        this.buttonTop = this.el.find('button.top');

        this.scrollContent = this.el.find('.right');

        this.bind();
    },

    bind() {
        this.buttonHide.on("click", function (element) {
            DetailBox.hide();
        });

        $(document).on('mousewheel', '.right', function (event) {
            let scrollTop = $(this).scrollTop();

            if (scrollTop === 0) {
                DetailBox.buttonTop.addClass("hidden");
            } else {
                DetailBox.buttonTop.removeClass("hidden");
            }
        });

        this.buttonTop.on('click', function () {
            $(this).addClass("hidden");

            DetailBox.scrollContent.animate({
                scrollTop: 0
            }, 200);
        });
    },

    show() {
        if (!this.el.is(".hidden")) {

            DetailBox.hide();

            setTimeout(() => {
                DetailBox.show();
            }, 500);

            return;
        }

        DetailBox.showLoading();

        $("section[element='content']").css("overflow-y", "hidden");

        this.el.removeClass("hidden");

        setTimeout(() => {
            DetailBox.focusSearchIfExist();
        }, 1500);
    },

    hide() {
        this.el.addClass("hidden");
        $("section[element='content']").css("overflow-y", "auto");
        DetailBox.loading.show(0);
    },

    showLoading() {
        this.loading.removeClass("hidden");
        DetailBox.resetContent();
    },

    hideLoading() {
        this.loading.addClass("hidden");
    },

    resetContent() {
        this.content.html("");
    },

    setScrollContent() {
        this.scrollContent = DetailBox.el.find('.right');
    },

    focusSearchIfExist() {
        DetailBox.content.find('[name="search"]').first().focus();
    }
}
export default DetailBox;